import { Pipe, PipeTransform, NgModule } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyArray = any[];

@Pipe({ name: 'where', standalone: false })
export class WherePipe implements PipeTransform {
  /**
   * Filters an array by a condition function, key-value pair, or exact match
   * @param input - The array to filter
   * @param fn - Filter function, [key, value] pair, or value to match
   * @returns Filtered array
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(input: AnyArray | undefined | null, fn: ((item: any) => boolean) | [string, any] | any): AnyArray {
    if (!Array.isArray(input)) {
      return input as any;
    }

    if (typeof fn === 'function') {
      return input.filter(fn);
    } else if (Array.isArray(fn)) {
      const [key, value] = fn;
      return input.filter((item) => this.getProperty(item, key) === value);
    } else if (fn) {
      return input.filter((item) => item === fn);
    } else {
      return input;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private getProperty(value: any, key: string): any {
    if (value == null || typeof value !== 'object') {
      return undefined;
    }
    const keys = key.split('.');
    let result = value[keys.shift()!];
    for (const k of keys) {
      if (result == null || typeof result !== 'object') {
        return undefined;
      }
      result = result[k];
    }
    return result;
  }
}

@NgModule({
  declarations: [WherePipe],
  exports: [WherePipe],
})
export class NgWherePipeModule {}
